import { TRESPONSE_NPT_REASONS_LIST } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableRowNode } from '../../table.type';

export const NPT_REASONS_TABLE_MODEL = {
  createModel: (data: TRESPONSE_NPT_REASONS_LIST['nptReasons'], hasDeleteAccess: boolean) => {
    return ModifiersZTableModel.createTableModel(
      data,
      {
        padding: 8,
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'table_model.REASON',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.SUB-CATEGORY',
          },
          ...(hasDeleteAccess
            ? [
                {
                  type: 'TEXT_CELL' as const,
                  text: '',
                  widthInPx: 100,
                },
              ]
            : []),
        ],
      },
      (item): TTableRowNode<TRESPONSE_NPT_REASONS_LIST['nptReasons'][number]> => ({
        cells: [
          {
            type: 'TEXT_CELL',
            text: item.category,
          },
          {
            type: 'TEXT_CELL',
            text: item.subCategory,
          },
          ...(hasDeleteAccess
            ? [
                {
                  type: 'ACTION_CELL' as const,
                  actionType: 'DELETE' as const,
                  asIcon: true,
                },
              ]
            : []),
        ],
        rowItem: item,
        type: 'ROW',
      }),
    );
  },
};
